import type { DriveStep } from "driver.js";

export const ARRIVALS_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="arrivals-day-picker"]',
    popover: {
      title: "Tag wählen",
      description:
        "Wechseln Sie zwischen heute und den kommenden Tagen. Die Zahl unter jedem Tag zeigt, wie viele Anreisen noch ausstehen.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="arrivals-table"]',
    popover: {
      title: "Anreiseliste",
      description:
        "Alle Gäste mit geplanter Anreise am gewählten Tag, die noch nicht eingecheckt sind. Klicken Sie auf eine Zeile für Buchungsdetails.",
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="arrivals-actions"]',
    popover: {
      title: "Check-in",
      description:
        "„Comfort Check-in“ schickt dem Gast eine E-Mail. Dort gibt er das Kennzeichen an und bezahlt online. Nach dem Abschluss erscheint das in der Liste. „Einchecken“ startet den Check-in an der Rezeption und ist nur am Anreisetag möglich.",
      side: "left",
      align: "center",
    },
  },
];
